import { postWithAuth, getWithAuth, putWithAuth } from "../../Basic/HttpService";

export const getAllAdminDash = async () => {
  let res = await getWithAuth(`AdminDashboard`);
  return res;
};
